const CUTOUT_FALLBACK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
  <rect width="30" height="30" fill="#f0f0f0" stroke="#ccc" stroke-width="1"/>
  <rect x="7" y="9" width="16" height="12" rx="1" fill="none" stroke="#999" stroke-width="1.5"/>
  <circle cx="12" cy="14" r="1.5" fill="#999"/>
  <path d="M7 19 L12 15 L16 17 L23 12" fill="none" stroke="#999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export const CUTOUT_FALLBACK_IMAGE =
    'data:image/svg+xml,' + encodeURIComponent(CUTOUT_FALLBACK_SVG);

export function getCutoutImageUrl(imageUrl: string | null | undefined): string {
    if (imageUrl?.trim()) {
        return imageUrl;
    }

    return CUTOUT_FALLBACK_IMAGE;
}
